export default "__VITE_ASSET__BWpu3fY2__"